import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Favorite } from '../_models/favorite';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getFavoriteByResourceId(resourceId: string) {
    return this.http.get<Favorite>(`${environment.apiUrl}/Favorites/GetByResourceId/${resourceId}`, { headers: this.authService.headers }).toPromise();
  }

  add(favorite: Favorite) {
    return this.http.post<Favorite>(`${environment.apiUrl}/Favorites`, favorite, { headers: this.authService.headers }).toPromise();
  }

  delete(favoriteId: string) {
    return this.http.delete<Favorite>(`${environment.apiUrl}/Favorites/${favoriteId}`, { headers: this.authService.headers }).toPromise();
  }
}
